import workspaceQuery from '../../../graphql/queries/supplier/PurchaseTransactionWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/supplier/PurchaseTransactionListQuery.graphql';
import instanceQuery from '../../../graphql/queries/supplier/PurchaseTransactionQuery.graphql';
import defaultQuery from '../../../graphql/queries/supplier/PurchaseTransactionDefault.graphql';
import mutationQuery from '../../../graphql/mutations/supplier/PurchaseTransactionMutation.graphql';
import fragment from '../../../graphql/fragments/supplier/PurchaseTransactionFragment.graphql';
import { workspaceActionsForPermissions } from '../../../actions/purchasing/PurchaseTransactionWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import aggregateQuery from '../../../graphql/queries/supplier/PurchaseTransactionAggregateQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseTransaction: EntityType = {
  type: 'PurchaseTransaction',
  title: 'Purchase Transactions',
  formTitle: 'Purchase Transaction',
  formUrl: '/Suppliers/Transaction/Details/',
  workspaceUrl: '/Suppliers/Transaction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SUPPLIER_TRANSACTIONS',
  actions: workspaceActionsForPermissions,
  operations: ALLOW_VIEW,
};

export default PurchaseTransaction;
